import axios from "axios";
import { base_url } from "..";

const getMethod = (url: any) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .get(`${base_url}/${url}`)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });

  return promise;
};

const postMethod = (url: any, data: any) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .post(`${base_url}/${url}`, data)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
  return promise;
};

const putMethod = (url: any, data: any) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .put(`${base_url}/${url}`, data)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
  return promise;
};

const API = {
  getMethod,
  postMethod,
  putMethod,
};
export default API;
